import { useRef } from 'react';

import useReduxToolkit from 'hooks/useReduxToolkit';

import type { Params, UseGlobalStore } from './types';

const useGlobalStore: UseGlobalStore = ({ namespace }: Params) => {
    const storeMap = useRef({
        reduxToolkit: useReduxToolkit
    }).current;

    return storeMap.reduxToolkit({ namespace });
};

export default useGlobalStore;
